<template>
  <div></div>
</template>

<script>
export default {
  name: 'YunCang',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped>
</style>